import { Dayjs } from "@/components/dayjsExtended.ts";

import { Building } from "./building.ts";

export interface Account {
  id: number;
  name: string;
  type: AccountType;
  identifier: string;
  primaryUserId?: number | null;
}

export enum AccountType {
  ORGANIZATION = "ORGANIZATION",
  INDIVIDUAL = "INDIVIDUAL",
}

export interface UserInfoRaw {
  userId: number;
  email: string;
  name: string;
  createdAt: string;
  authorities: string[];
  language: string;
  accounts: AccountInfoAccount[];
}

export interface UserInfo extends UserInfoRaw {
  createdAtTimestamp: Dayjs;
}

export interface AccountInfoAccount extends Account {
  managedBuildings: Building[];
}

export interface UnassignAccountRequest {
  accountId: number;
}

export interface AssignAccountRequest {
  type: AccountType;
  individualAccount?: AssignAccountRequestIndividual;
  organizationAccount?: AssignAccountRequestOrganization;
}

export interface AssignAccountRequestIndividual {
  email: string;
  name?: string;
}

export interface AssignAccountRequestOrganization {
  registryCode: string;
  name?: string;
  firstUserEmail?: string;
  firstUserName?: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
}

export enum AssignAccountResponse {
  SUCCESS = "SUCCESS",
  MORE_INFO_REQUIRED = "MORE_INFO_REQUIRED",
}

// Assignment types (mirror backend s)
export enum AssignmentEntityType {
  BUILDING = "BUILDING",
  HOUSEHOLD = "HOUSEHOLD",
}

export interface AccountAssignmentUser {
  id: number;
  name: string;
  email: string;
}

export interface AccountAssignment {
  id: number;
  type: AccountType;
  name: string;
  registryCode?: string | null;
  users: AccountAssignmentUser[];
}

export interface AccountAssignmentList {
  assignments: AccountAssignment[];
}
